"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardMedia = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

var _core = require("@emotion/core");

const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  image: _propTypes.string,
  src: _propTypes.string,
  style: _propTypes.object,
  ref: _propTypes.object
} : {};

const CardMedia = ({
  className,
  component: Component = 'div',
  image,
  src,
  style,
  ref,
  ...other
}) => {
  const UsedComponent = _components.CardMediaStyled.withComponent(Component, {
    target: "e18mq5os0"
  });

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  const composedStyle = !isMediaComponent && image ? {
    backgroundImage: `url("${image}")`,
    ...style
  } : style;
  return (0, _core.jsx)(UsedComponent, (0, _extends2.default)({
    css: _stylitas.cardMediaBase,
    className: className,
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined,
    isMedia: isMediaComponent
  }, other));
};

exports.CardMedia = CardMedia;
process.env.NODE_ENV !== "production" ? CardMedia.propTypes = propTypes : void 0;